const phoneNumberRegExp = /^010-?([0-9]{4})-?([0-9]{4})$/;

export const phoneNumberValidation = (num: string) => {
  if (num !== '') {
    return phoneNumberRegExp.test(num);
  }
  return true;
};
